import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

let app: firebase.app.App | undefined = undefined;

if (!firebase.apps.length) {
    app = firebase.initializeApp(firebaseConfig);

    firebase
        .auth()
        .setPersistence(
            process.env.NODE_ENV === "development"
                ? firebase.auth.Auth.Persistence.LOCAL
                : firebase.auth.Auth.Persistence.SESSION
        );
    firebase.firestore().settings({ experimentalForceLongPolling: true });
    firebase.firestore().enablePersistence({ synchronizeTabs: true });
}

export default app;
